<template>
    <div class="ai-stats my-2">
        <StatsBar
            :stats="{ pass: spec.compliant, fail: spec.nonCompliant }"
            :stats-before="statsBefore"
            :statistics="{
                totalEmailsReported: spec.compliant + spec.nonCompliant,
                dmarcCompliant: spec.compliant,
                dmarcNonCompliant: spec.nonCompliant,
                complianceRate: spec.complianceRate,
            }"
        />
    </div>
</template>

<script lang="ts" setup>
import { computed } from "vue";
import StatsBar from "@/Pages/Reports/components/StatsBar.vue";
import type { AiStatsSpec } from "@/Pages/AiChat/markdown";

const props = defineProps<{
    spec: AiStatsSpec;
}>();

const statsBefore = computed(() =>
    props.spec.before
        ? {
              pass: props.spec.before.compliant,
              fail: props.spec.before.nonCompliant,
          }
        : null,
);
</script>

<style scoped>
/* Chat-only override of the shared StatsBar: in narrow chat containers (mini
   widget, squeezed big chat) the viewport-based md:grid-cols-4 would cram four
   tiles into a ~350px box, so the tiles stack vertically instead. StatsBar
   itself stays untouched for the Dashboard and Reports pages. */
@container (max-width: 32rem) {
    .ai-stats :deep(.grid) {
        grid-template-columns: 1fr;
        gap: 0.75rem;
    }

    .ai-stats :deep(.grid > div) {
        padding: 1rem;
    }
}
</style>
